const languageSelector = document.querySelector('select[data-js="language-selector"]');

if (languageSelector) {
    languageSelector.addEventListener('change', (e) => {
        window.location.replace((e.target as HTMLOptionElement).value);
    });
}

export {};
